import React from "react";

import { WarningIcon } from "../SVGIcons";

interface ErrorModalProps {
  title: string;
  message: string;
  onClose?: () => void;
  onRetry?: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  title,
  message,
  onClose,
  onRetry,
}) => {
  return (
    <>
      {/* オーバーレイ */}
      <div
        className="fixed inset-0 z-300 transition-opacity"
        style={{ backgroundColor: "rgba(107, 114, 128, 0.5)" }}
      />

      {/* モーダル本体 */}
      <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-md">
        <div className="bg-white rounded-lg shadow-xl">
          {/* ヘッダー */}
          <div className="p-6 pb-4">
            {/* タイトル行（アイコンとタイトル） */}
            <div className="flex items-center justify-center">
              {/* 警告アイコン */}
              <WarningIcon className="h-6 w-6 text-red-600" />

              {/* タイトル */}
              <h3 className="ml-3 text-lg font-semibold text-gray-900">
                {title}
              </h3>
            </div>

            {/* メッセージ */}
            <div className="mt-4">
              <p
                className="text-sm text-gray-600"
                style={{ whiteSpace: "pre-line" }}
              >
                {message}
              </p>
            </div>

            {/* ボタン（中央配置） */}
            <div className="mt-6 flex justify-center gap-3">
              {onClose && (
                <button
                  type="button"
                  onClick={onClose}
                  className="inline-flex justify-center rounded-md border border-gray-300 bg-white px-6 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                >
                  閉じる
                </button>
              )}
              {onRetry && (
                <button
                  type="button"
                  onClick={() => {
                    onRetry();
                  }}
                  className="inline-flex justify-center rounded-md border border-transparent bg-red-600 px-6 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                >
                  リトライ
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorModal;
